import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { useId } from "react";

import { cn } from "@/shared/lib";

import { formatClock } from "../../model/formatClock";
import type { HighlightView } from "../../model/Highlight";
import { useHighlightTitle } from "../HighlightParts";

const HEADING = msg`Clips from this match`;
const WATCH = msg`Watch: {title} at {time}`;

type ClipStripProps = {
  // Готовые клипы матча по порядку плиток раздела.
  clips: HighlightView[];
  currentId: number;
  onOpen: (highlight: HighlightView) => void;
};

// Лента «Клипы этого матча» под плеером (доска 18е): кадр, название и время в матче,
// открытый клип выделен.
export const ClipStrip = ({ clips, currentId, onOpen }: ClipStripProps) => {
  const { i18n } = useLingui();
  const headingId = useId();
  const title = useHighlightTitle();
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-2">
      <span id={headingId} className="text-[13px] text-subtle">
        {i18n._(HEADING)}
      </span>
      <ol className="grid grid-cols-[repeat(auto-fill,minmax(120px,1fr))] gap-2">
        {clips.map((clip) => {
          const current = clip.id === currentId;
          const time = formatClock(clip.game_time_s);
          return (
            <li key={clip.id}>
              <button
                type="button"
                aria-current={current}
                aria-label={i18n._({ ...WATCH, values: { title: title(clip), time } })}
                onClick={() => {
                  onOpen(clip);
                }}
                className={cn(
                  "flex w-full cursor-pointer flex-col gap-1 rounded-[9px] border bg-background p-1 text-left outline-none focus-visible:ring-2 focus-visible:ring-accent/60",
                  current
                    ? "border-accent ring-2 ring-accent/25"
                    : "border-sidebar-active hover:border-border-strong",
                )}
              >
                {clip.clip.poster_url === null ? (
                  <span className="block aspect-video w-full rounded-md bg-black" />
                ) : (
                  <img
                    src={clip.clip.poster_url}
                    alt=""
                    loading="lazy"
                    className="block aspect-video w-full rounded-md object-cover"
                  />
                )}
                <span className="flex justify-between gap-1.5 px-0.5 text-xs leading-snug">
                  <span className="truncate text-foreground-soft">{title(clip)}</span>
                  <span className="font-mono text-subtle">{time}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
